/**
 * Microdose — AJAX add to cart with Dawn cart drawer / icon refresh (no page reload).
 */
(function () {
  'use strict';

  function getSectionInnerHTML(html, selector) {
    selector = selector || '.shopify-section';
    var parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return parsed ? parsed.innerHTML : '';
  }

  function getCartUI() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function getSectionsToRequest() {
    var cartUI = getCartUI();
    if (cartUI && typeof cartUI.getSectionsToRender === 'function') {
      return cartUI.getSectionsToRender().map(function (s) {
        return s.id;
      });
    }
    return ['cart-icon-bubble'];
  }

  function applyCartSections(sections, openDrawer) {
    if (!sections) return;

    var cartUI = getCartUI();
    var renderList =
      cartUI && typeof cartUI.getSectionsToRender === 'function'
        ? cartUI.getSectionsToRender()
        : [{ id: 'cart-icon-bubble' }];

    renderList.forEach(function (section) {
      if (!sections[section.id]) return;

      var sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;

      sectionElement.innerHTML = getSectionInnerHTML(
        sections[section.id],
        section.selector || '.shopify-section'
      );
    });

    if (cartUI) {
      cartUI.classList.remove('is-empty');
      var itemsEl = cartUI.querySelector('cart-drawer-items');
      if (itemsEl) itemsEl.classList.remove('is-empty');

      if (openDrawer && typeof cartUI.open === 'function') {
        setTimeout(function () {
          var overlay = cartUI.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', cartUI.close.bind(cartUI));
          cartUI.open();
        });
      }
    }
  }

  function fetchCartSections() {
    var ids = getSectionsToRequest().join(',');
    return fetch(window.location.pathname + '?sections=' + ids).then(function (r) {
      return r.json();
    });
  }

  function publishCartUpdate(cartData) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'microdose-cart',
        cartData: cartData,
      });
    }
    window.dispatchEvent(
      new CustomEvent('microdose:cart-updated', {
        detail: { cart: cartData },
      })
    );
  }

  /**
   * @param {number|string} variantId
   * @param {Object} [options]
   * @param {number} [options.quantity]
   * @param {number|string} [options.sellingPlanId]
   * @param {boolean} [options.openDrawer]
   * @returns {Promise}
   */
  window.microdoseAddToCart = function (variantId, options) {
    options = options || {};

    if (!variantId) {
      return Promise.reject(new Error('No variant selected'));
    }

    if (!window.routes || !window.routes.cart_add_url) {
      return Promise.reject(new Error('Cart routes unavailable'));
    }

    var formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', String(options.quantity || 1));

    if (options.sellingPlanId) {
      formData.append('selling_plan', String(options.sellingPlanId));
    }

    var sectionIds = getSectionsToRequest();
    if (sectionIds.length) {
      formData.append('sections', sectionIds.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
      },
      body: formData,
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok && !data.status) {
            throw new Error(data.description || data.message || 'Add to cart failed');
          }
          return data;
        });
      })
      .then(function (response) {
        if (response.status) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'microdose-cart',
              errors: response.description,
              message: response.message,
            });
          }
          throw new Error(response.description || response.message || 'Add to cart failed');
        }

        var openDrawer = options.openDrawer === true;

        if (response.sections) {
          applyCartSections(response.sections, openDrawer);
        } else {
          return fetchCartSections().then(function (sections) {
            applyCartSections(sections, openDrawer);
          });
        }

        return fetch('/cart.js', {
          headers: { Accept: 'application/json' },
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            publishCartUpdate(cart);
            return { response: response, cart: cart };
          });
      });
  };

  window.microdoseRefreshCart = function (openDrawer) {
    return fetchCartSections().then(function (sections) {
      applyCartSections(sections, openDrawer === true);
      return fetch('/cart.js', {
        headers: { Accept: 'application/json' },
      }).then(function (r) {
        return r.json();
      }).then(function (cart) {
        publishCartUpdate(cart);
        return cart;
      });
    });
  };
})();
